import { denormalisedResponseEntities, onGetCloudnaryData } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess } from '../../ducks/user.duck';
import { UploadImage } from '../../util/cloudinary';
import { convertFileToMd5, mountFileToSend } from '../../util/circleHelper';
import {
  createDirectUpload,
  fetchCommunityMember,
  onGetCircleAuthToken,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import { updateCurrentCircleUserApi } from '../../util/api';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const UPDATE_PROFILE_CIRCLE_IMAGE = 'app/ProfileSettingPage/UPDATE_PROFILE_CIRCLE_IMAGE';

// ================ Reducer ================ //

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,
  circleData: null
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROFILE_CIRCLE_IMAGE:
      return {
        ...state,
        circleData: payload
      }
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage, cloudProfileImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage, cloudProfileImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

// Save signed_id in the duck when save button is click update the circle
export const circleSuccess = data => ({ type: UPDATE_PROFILE_CIRCLE_IMAGE, payload: data.data });

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //


export function updateCurrentCircleUserData(actionPayload) {
  return async (dispatch, getState, sdk) => {
    try {
      const { data } = actionPayload
      const email = getState()?.user?.currentUser?.attributes?.email;
      const { access_token } = await onGetCircleAuthToken(email);
      console.log('updateUserCircleProfileImage');
      const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data: data });

      return profileResponse;
    } catch (e) {
      console.log(e, '^^^  ^^^ => e');
    }
  }
}


const updateUserCircleProfileImage = async (file, dispatch, getState) => {
  try {
    const md5 = await convertFileToMd5(file);
    const fileMetadata = mountFileToSend(file, md5);
    const response = await dispatch(createDirectUpload(fileMetadata, file));
    const { signed_id } = response || {};
    const data = { community_member: { avatar: signed_id } };

    return data;

  } catch (error) {
    console.log('error', error);
  }
};

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const { id, file } = actionPayload;

    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(async resp => {
        const uploadedImage = resp.data.data;
        const data = await updateUserCircleProfileImage(file, dispatch, getState);
        // <<<<<<<< upload image in cloudnary >>>>>>>>>>>>>>>
        const cloudnaryResponse = await UploadImage({ id: uploadedImage.id.uuid, file });
        dispatch(
          uploadImageSuccess({
            data: { id, uploadedImage, cloudProfileImage: onGetCloudnaryData(cloudnaryResponse) },
          })
        );
        dispatch(circleSuccess({ data }))
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

const updateCircleProfile = async (actionPayload, dispatch, getState) => {
  const email = getState()?.user?.currentUser?.attributes?.email;
  const userId = getState()?.user?.currentUser?.id.uuid;
  const { access_token, community_member_id } = await onGetCircleAuthToken(email);
  await dispatch(fetchCommunityMember(access_token, community_member_id));
  const { firstName, lastName, bio, displayName } = actionPayload;

  const { currentCommunityMember } = getState()?.CircleCommunityPage;
  const { profile_fields } = currentCommunityMember || {};
  const bioField = profile_fields?.visible?.find(item => item.key === 'bio');

  const bioParams = {
    textarea: bio || '',
    profile_field_id: bioField?.id,
    id: bioField?.community_member_profile_field?.id || null,
  };

  const data = {
    community_member: {
      ...(firstName && lastName && { name: displayName || `${firstName} ${lastName}` }),
      headline: userId,
      community_member_profile_fields_attributes: [...(bio ? [bioParams] : [])],
    },
  };

  const profileResponse = await updateCurrentCircleUserApi({ accessToken: access_token, data });
};

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(response => {
        dispatch(updateProfileSuccess(response));
        updateCircleProfile(actionPayload, dispatch, getState);
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];

        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};
